import styled from 'styled-components';
import {basicColor} from '@/styles/template';
import SuccessMessage from '../SuccessMessage/SuccessMessage';

const ErrorMessage = styled(SuccessMessage)`
    color: ${basicColor.red};
    background: ${basicColor.redTransparent};
    white-space: pre-line;
`;

export default ErrorMessage